import React from 'react';

function Arrow() {
	return (
		<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 180">
			<path className="arrow-st0" d="M90,0C40.3,0,0,40.3,0,90c0,49.7,40.3,90,90,90s90-40.3,90-90C180,40.3,139.7,0,90,0z M90,175c-46.9,0-85-38.1-85-85C5,43.1,43.1,5,90,5c46.9,0,85,38.1,85,85C175,136.9,136.9,175,90,175z"/>
			<path className="arrow-st0" d="M142.9,85.9H42.3l49.5-49.5c1-1,1-2.6,0-3.5c-1-1-2.6-1-3.5,0L34.5,86.6c0,0,0,0,0,0c-1,1-1,2.6,0,3.5l53.8,53.8c0.5,0.5,1.1,0.7,1.8,0.7s1.3-0.2,1.8-0.7c1-1,1-2.6,0-3.5L42.3,90.8h100.7c1.4,0,2.5-1.1,2.5-2.5S144.3,85.9,142.9,85.9z"/>
		</svg>
	);
}

export default Arrow;


/** WEBPACK FOOTER **
 ** ./src/modules/images/arrow.js
 **/